import brand from "../inc/branding.json";

const rawDba = String(brand?.brandConfig?.config?.dba || "").trim();
const dba = rawDba || "App";
const storageSafeDba = dba.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "app";

export const appConfig = {
  mfaIssuer: dba,
  mfaStoragePrefix: `${storageSafeDba}:mfa`,
  loaderSpinKeyframe: `${storageSafeDba}-spin`,
};

export default appConfig;
